import { Grid, makeStyles, TextField } from "@material-ui/core";
import React, { useEffect, useState } from "react";
import { InstructorUserUpdate } from "../interfaces/InstructorUserUpdate";

interface Props {
  translations: {
    label;
  };
  phoneNumber: string;
  setInstructorUserData: (data: Partial<InstructorUserUpdate>) => void;
  loading: boolean;
}

const useStyles = makeStyles((theme) => ({
  input: {
    marginBottom: "20px",
    border: "2px solid #fee9ee",
    borderRadius: "12px",
    height: "52px",
    background: theme.palette.background.default,
    transition: "background .25s, border .25s",
    "&.MuiFormControl-root:has(.Mui-focused)": {
      border: "2px solid #FD9BB5",
      background: "#fee9ee",
    },
    "& .MuiFilledInput-root": {
      background: "none",
      height: "46px",
    },
    "& .MuiFilledInput-underline:after": {
      borderBottom: "none",
    },
    "& .MuiFilledInput-underline:before": {
      borderBottom: "none",
    },
    "& .MuiFormLabel-filled": {
      color: theme.palette.primary.main,
    },
    "& .MuiInputLabel-root": {
      fontWeight: 600,
    },
  },
}));

export const PhoneNumberInput: React.FC<Props> = (props) => {
  const { translations, phoneNumber, setInstructorUserData, loading } = props;
  const classes = useStyles();
  const [phoneNumberInput, setPhoneNumberInput] = useState<string>(phoneNumber);
  useEffect(() => {
    if (phoneNumberInput) {
      setInstructorUserData({ phoneNumber: phoneNumberInput });
    } else {
      setInstructorUserData({ phoneNumber: null });
    }
  }, [phoneNumberInput]);

  return (
    <Grid item>
      <TextField
        disabled={loading}
        fullWidth
        variant={"filled"}
        label={translations.label}
        className={classes.input}
        defaultValue={phoneNumberInput}
        onChange={(e) => setPhoneNumberInput(e.target.value)}
      />
    </Grid>
  );
};
